import { Paper } from "@commonlibs";
import styled, { css } from "styled-components";

export const BottomCardRoot = styled(Paper).attrs({ elevation: 0 })(
    ({ theme }) => css`
        width: 100%;
        border-radius: 0;
        border-top-left-radius: ${theme.borderRadius};
        border-top-right-radius: ${theme.borderRadius};
    `,
);
